// 推送设置
export default {
  BASE_URL: '',
  api: [
    {
      name: 'save',
      desc: '推送设置-保存',
      method: 'POST',
      path: '/fm/kingdee/setting/save'
    },
    {
      name: 'getLatestSetting',
      desc: '推送设置-详情(只会返回最新的一条)',
      method: 'GET',
      path: '/fm/kingdee/setting/getLatestSetting'
    },
    {
      name: 'getSettingLog',
      desc: '推送设置-操作记录',
      method: 'GET',
      path: '/fm/kingdee/setting/getSettingLog'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/push/pushSettings.js